/**
 * 主题配置文件
 * 用于管理网站的主题系统（配置驱动模式）
 * 
 * 通过环境变量 VITE_THEME 控制主题：
 * - classic: 经典蓝色主题
 * - dark: 现代深色主题
 * 
 * 使用方式：
 * - 开发时：VITE_THEME=dark npm run dev
 * - 构建时：VITE_THEME=dark npm run build
 * - 或在 .env 文件中设置 VITE_THEME=dark
 */

// 主题常量
export const THEMES = {
  CLASSIC_BLUE: 'classic',
  MODERN_DARK: 'dark'
};

// 主题显示名称
export const THEME_NAMES = {
  [THEMES.CLASSIC_BLUE]: {
    zh: '经典蓝色',
    en: 'Classic Blue'
  },
  [THEMES.MODERN_DARK]: {
    zh: '现代深色',
    en: 'Modern Dark'
  }
};

export const CURRENT_THEME = THEMES.MODERN_DARK;

// 应用主题到 DOM
export const applyTheme = (theme) => {
  if (typeof document !== 'undefined') {
    const root = document.documentElement;
    if (theme === THEMES.MODERN_DARK) {
      root.setAttribute('data-theme', 'dark');
    } else {
      root.removeAttribute('data-theme');
    }
  }
};

// 判断是否为深色主题
export const isDarkTheme = () => CURRENT_THEME === THEMES.MODERN_DARK;

// 判断是否为经典主题
export const isClassicTheme = () => CURRENT_THEME === THEMES.CLASSIC_BLUE;

// 主题配置导出
export default {
  THEMES,
  THEME_NAMES,
  CURRENT_THEME,
  applyTheme,
  isDarkTheme,
  isClassicTheme
};
